export default __webpack_public_path__ + "static/media/production.15405e88.svg";